import styled from 'styled-components';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import useUsersMasterTable, {
  useKidRow,
} from 'hooks/service/useUsersMasterTable';
import Loading from 'components/common/Loading';
import Modal from 'components/common/Modal';
import { useState } from 'react';
import autoHyphen from 'utils/autoHyphen';
import { PasswordLock } from 'lib/styles/icons';
import palette from 'lib/styles/palette';

const ResetModal = ({ setShowResetModal }) => {
  return (
    <Modal closeModal={() => setShowResetModal(false)}>
      <ResetModalBlock>
        <PasswordLock className="reset-modal-icon" />
        <div>비밀번호 초기화 a1234567</div>
      </ResetModalBlock>
    </Modal>
  );
};

const ResetModalBlock = styled.div`
  padding: 2rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-weight: bold;

  .reset-modal-icon {
    font-size: 50px;
    margin-bottom: 20px;
  }
`;

const KidRow = ({ kid, i, setShowResetModal }) => {
  const { name, code, tel, isTelValidated, onChange, onUpdate, onReset } =
    useKidRow(kid.id, setShowResetModal);
  const editedTel = autoHyphen(kid.tel);

  return (
    <KidRowBlock>
      <div>{i + 1}</div>
      <div>{kid.userId}</div>
      {kid.name ? (
        <div>{kid.name}</div>
      ) : (
        <div>
          <input type="text" name="name" value={name} onChange={onChange} />
        </div>
      )}
      {kid.code ? (
        <div>{kid.code}</div>
      ) : (
        <div>
          <input type="text" name="code" value={code} onChange={onChange} />
        </div>
      )}
      {kid.tel ? (
        <div>{editedTel}</div>
      ) : (
        <div>
          <input type="text" name="tel" value={tel} onChange={onChange} />
        </div>
      )}
      <div>
        {!kid.name || !kid.code || !kid.tel ? (
          <button
            className="btn"
            onClick={onUpdate}
            disabled={name.length === 0 || code.length === 0 || !isTelValidated}
          >
            사용자 지정
          </button>
        ) : (
          <button className="btn" onClick={onReset}>
            초기화
          </button>
        )}
      </div>
    </KidRowBlock>
  );
};

const KidRowBlock = styled.div`
  margin-top: 0.3rem;
  display: flex;
  justify-content: space-between;

  div {
    width: 100%;
    text-align: center;
  }

  input {
    width: 90%;
    padding: 3px 10px;
    font-size: 12px;
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: #fff;
  }

  button {
    &:disabled {
      background-color: ${palette.theme[0]};
      &:hover {
        background-color: ${palette.theme[0]};
      }
    }
  }
`;

const UsersMasterTable = () => {
  const [showResetModal, setShowResetModal] = useState(false);
  const { getMasterUsers, userType } = useUsersMasterTable();

  if (userType !== '1') return <></>;

  if (getMasterUsers.isLoading || getMasterUsers.error?.response.status === 401)
    return <Loading />;

  const kids = getMasterUsers.data?.data.kids;
  const master = getMasterUsers.data?.data.master;
  const tel = autoHyphen(master?.tel);

  return (
    <>
      {showResetModal && <ResetModal setShowResetModal={setShowResetModal} />}
      <UsersMasterTableBlock>
        <div className="title">Master</div>
        <div className="box">
          <div className="master-table-header">
            <div>Master ID</div>
            <div>사용자</div>
            {master?.code && <div>사원번호</div>}
            <div>연락처</div>
          </div>
          <div className="master-table-row">
            <div>{master?.userId}</div>
            <div>{master?.name}</div>
            {master?.code && <div>{master?.code}</div>}
            <div>{tel}</div>
          </div>
        </div>
        <div className="title">Master Kids</div>
        <div className="box">
          <div className="master-table-row bold">
            <div>번호</div>
            <div>Master Kids ID</div>
            <div>사용자</div>
            <div>사원번호</div>
            <AiOutlineQuestionCircle className="question-icon" />
            <div className="hide">
              사원 번호, 이메일 등 사원식별번호를 입력해서 마스터 키즈 아이디
              사용자에게 전달해주세요
            </div>
            <div>연락처</div>
            <div />
          </div>
          {kids?.length === 0 && (
            <div className="no-mater-kid">마스터 키즈가 없습니다</div>
          )}
          {kids &&
            kids?.map((kid, i) => (
              <KidRow
                key={kid.id}
                kid={kid}
                i={i}
                setShowResetModal={setShowResetModal}
              />
            ))}
        </div>
      </UsersMasterTableBlock>
    </>
  );
};

export default UsersMasterTable;

const UsersMasterTableBlock = styled.div`
  .title {
    margin-top: 1rem;
  }

  .box {
    margin-top: 1rem;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
  }

  .master-table-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;

    div {
      width: 100%;
      text-align: center;
    }
  }

  .master-table-row {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    position: relative;

    div {
      width: 100%;
      text-align: center;
    }

    .hide {
      width: 160px;
      padding: 0.3rem 0.5rem;
      border: 1px solid black;
      border-radius: 10px;
      background: #fff;
      font-size: 10px;
      z-index: 300;
      position: absolute;
      top: -10px;
      right: 200px;
      display: none;
    }
  }

  .question-icon {
    top: 1px;
    right: 375px;
    position: absolute;
    cursor: pointer;
  }

  .question-icon:hover + .hide {
    display: block;
  }

  .no-mater-kid {
    padding: 2rem 0;
    font-weight: 500;
    text-align: center;
  }
`;
